import { api } from "./api/api";

export interface IFilter {
  campo: string;
  campo_original: string;
  tipo: string;
  valores: string[]
  layerUuid?: string;
  layerId?: string;
  layerTitle?: string;
}

export async function getSimpleFilterValues(
  idCamada: string,
  layer_query_filter: string,
): Promise<IFilter[]> {
  const response = await api.get<IFilter[]>(
    '/filtros-geoserver/',
    {
      params: {
        id: idCamada,
        layer_query_filter: layer_query_filter,
      }
    }
  );
  
  return response.data;
}

export async function getFilterValues(
  idCamada: string,
  coluna: string,
  layer_query_filter: string,
  filter: string,
  is_number: boolean,
  page: number,
): Promise<any> {
  const response = await api.get<any>(
    '/unique-values-geoserver/',
    {
      params: {
        controle_camadas_id: idCamada,
        column: coluna,
        page: page,
        size: 100,
        filter: filter,
        cql: layer_query_filter,
        ...(is_number && { is_number })
      }
    }
  );
  
  return response.data;
}
